/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_ArtifactInputs */

const en_reading_class_artifact = /** @type {(inputs: Reading_Class_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stray marks`)
};

const es_reading_class_artifact = /** @type {(inputs: Reading_Class_ArtifactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcas sueltas`)
};

/**
* | output |
* | --- |
* | "Stray marks" |
*
* @param {Reading_Class_ArtifactInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_artifact = /** @type {((inputs?: Reading_Class_ArtifactInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_ArtifactInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_artifact(inputs)
	return en_reading_class_artifact(inputs)
});